import React, { useState }  from 'react';
import { useDispatch, useSelector } from 'react-redux';
import 'tailwindcss/tailwind.css';

import { jobsReport } from '../../features/jobRoutes/jobRouteSlice';
import FormDatePicker from '../formHelpers/FormDatePicker';
import AreaSelectBox from '../dropdowns/AreaSelectBox';
import { formatDateToMMDDYYYY } from '../../utils/TextTools';
import HeaderTitleBar from '../HeaderTitleBar';
import FormSubmissionResult from '../formHelpers/FormSubmissionResult';

const JobsReport = () => {
  const dispatch = useDispatch();

  const [selectedStartDate, setSelectedStartDate] = useState(new Date());
  const [selectedEndDate, setSelectedEndDate] = useState(new Date());
  const [selectedAreaId, setSelectedAreaId] = useState(null);
  const [approvalType, setApprovalType] = useState('0');

  const { success, error } = useSelector((state) => state.billing)

  const handleStartChange = (date) => {
    setSelectedStartDate(date);
  }

  const handleEndChange = (date) => {
    setSelectedEndDate(date);
  }

  const handleAreaChange = (e) => {
    const { value } = e.target;
    setSelectedAreaId(value);
  }

  const handleApprovalType = (e) => {
    const selectedType = e.target.value;
    setApprovalType(selectedType)
  };


  const handleGenerate = (e) => {
    e.preventDefault();
    let areaId = selectedAreaId;

    if (parseInt(areaId) === 0 || typeof(areaId) === 'undefined') {
      areaId = 0
    }

    dispatch(jobsReport({reportParams: {
      start_date: formatDateToMMDDYYYY(selectedStartDate),
      end_date: formatDateToMMDDYYYY(selectedEndDate),
      area_id: selectedAreaId,
      approval: approvalType
    }}));
  }

  return (
    <>
      <div className="p-4 mb-6 bg-white shadow rounded-lg">
       <HeaderTitleBar
          title='Jobs Report'
          showBtn={false}
        />
      {error}
      {success}
        <FormSubmissionResult
          successText={`Export Created.  Check your email.`}
          success={success}
          error={error}
        />

        <form onSubmit={handleGenerate} className="w-1/2">
           <AreaSelectBox
              label={'Area'}
              name={'area_id'}
              value={selectedAreaId}
              onChange={handleAreaChange}
              useTarget={false}
              horizontal={true}
            />

            <FormDatePicker
              label={'Start Date'}
              name="start_date"
              onChange={handleStartChange}
              placeholder="Enter a Start Date"
              value={selectedStartDate}
              horizontal={true}
            />

            <FormDatePicker
              label={'End Date'}
              name="end_date"
              onChange={handleEndChange}
              placeholder="Enter an End Date"
              value={selectedEndDate}
              horizontal={true}
            />


            <div className="flex items-center mr-2">
              <input
                id={`approval_type`}
                type="radio"
                value="0"
                name={`approval_type`}
                className="w-4 h-4 border border-gray-300 rounded-sm shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                checked={approvalType === '0'}
                onChange={(e) => handleApprovalType(e)}
              />
              <label htmlFor={`approval_type`} className="ms-2 text-sm font-medium text-gray-500 whitespace-nowrap">
                All
              </label>
            </div>
            <div className="flex items-center mr-2">
              <input
                id={`approval_type`}
                type="radio"
                value="1"
                name={`approval_type`}
                className="w-4 h-4 border border-gray-300 rounded-sm shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                checked={approvalType === '1'}
                onChange={(e) => handleApprovalType(e)}
              />
              <label htmlFor={`approval_type`} className="ms-2 text-sm font-medium text-gray-500 whitespace-nowrap">
                Approved
              </label>
            </div>
            <div className="flex items-center mr-2 mb-4">
              <input
                id={`approval_type`}
                type="radio"
                value="2"
                name={`approval_type`}
                className="w-4 h-4 border border-gray-300 rounded-sm shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                checked={approvalType === '2'}
                onChange={(e) => handleApprovalType(e)}
              />
              <label htmlFor={`approval_type`} className="ms-2 text-sm font-medium text-gray-500 whitespace-nowrap">
                Denied
              </label>
            </div>

          <div className="flex md:items-center mb-6">
            <button className="bg-blue-600 text-white px-4 p-1">Generate Report</button>
          </div>
        </form>
      </div>
    </>
  );
};

export default JobsReport;